// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2-xFK","header":"PatientQuestionnaire_header__1C5II","info":"PatientQuestionnaire_info__xyIQW"};